<template>
  <div class="home-search d-lg-none mb-8">
    <div class="section-head">
      <span class="accent-dot" />
      <h2>Suche</h2>
    </div>
    <v-text-field
      v-model="trainNumber"
      label="Zugnummer"
      placeholder="z.B. 70 (für ICE 70)"
      prepend-inner-icon="mdi-train"
      append-inner-icon="mdi-magnify"
      @click:append-inner="navigateToTrain(trainNumber)"
      v-on:keydown.enter="navigateToTrain(trainNumber)"
      hide-details="auto"
      class="mb-3"
    />
    <v-text-field
      v-model="vehicle"
      label="Triebfahrzeug"
      placeholder="z.B. 9001 (f. Tz 9001)"
      prepend-inner-icon="mdi-tram-side"
      append-inner-icon="mdi-magnify"
      @click:append-inner="navigateToVehicle(vehicle)"
      v-on:keydown.enter="navigateToVehicle(vehicle)"
      hide-details="auto"
    />
    <v-btn
      variant="tonal"
      color="primary"
      block
      class="mt-3"
      prepend-icon="mdi-map-marker-path"
      :append-icon="oidcIsAuthenticated ? undefined : 'mdi-lock'"
      :to="{ name: 'connections' }"
    >
      Verbindung suchen
    </v-btn>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SearchNavigationMixin from '@/mixins/SearchNavigationMixin'

export default {
  name: 'HomeSearch',

  mixins: [SearchNavigationMixin],

  data: () => ({
    trainNumber: '',
    vehicle: '',
  }),

  computed: {
    // The button keeps leading to the page while signed out — it is the page that explains why
    // the search is shut — so the lock is the only advance warning the button can give.
    ...mapGetters('oidcStore', ['oidcIsAuthenticated']),
  },
};
</script>

<style scoped>
/* Same heading treatment as the page's other sections, so the block reads as
   part of Home rather than as the sidebar transplanted into it. */
.section-head {
  display: flex;
  align-items: center;
  gap: 11px;
  margin: 0 4px 14px;
}
.section-head h2 {
  font-size: 1.4rem;
  font-weight: 700;
  margin: 0;
}
.accent-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: rgb(var(--v-theme-accent));
}
</style>
